import { Toaster } from 'react-hot-toast';

/** Centralized toast renderer styled to the CRM tokens. Mount once at app root. */
export function ToastWrapper() {
  return (
    <Toaster
      position="top-right"
      toastOptions={{
        duration: 4000,
        style: {
          borderRadius: '12px',
          background: '#FFFFFF',
          color: '#111827',
          border: '1px solid #E5E7EB',
          boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
          fontSize: '13px',
          fontFamily: 'Poppins, sans-serif',
        },
        success: { iconTheme: { primary: '#10b981', secondary: '#fff' } },
        error: { iconTheme: { primary: '#ef4444', secondary: '#fff' } },
      }}
    />
  );
}
